module.exports = __webpack_public_path__ + "static/media/Celebración y Música.37b70982.png";